"use client";

import { useEffect } from "react";
import { useStore } from "@/hooks/use-store";
import { UtmParams } from "@/store/user-store";

export function UTMTracker() {
  const { user } = useStore();

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);

    const utmParams: UtmParams = {
      utm_source: params.get("utm_source"),
      utm_medium: params.get("utm_medium"),
      utm_campaign: params.get("utm_campaign"),
      utm_term: params.get("utm_term"),
      utm_content: params.get("utm_content"),
      utm_id: params.get("utm_id"),
    };

    user.setUtmParams(utmParams);
  }, []);

  return null;
}
